import { makeStyles } from "@material-ui/core";

export const useAdvancedListStyles = makeStyles((theme) => ({
  advancedListTable: {
    '& div.MuiDataGrid-colCell:focus-within, div.MuiDataGrid-cell:focus-within': {
      outline: 'none'
    }
  }
}))
